<template>
  <div>
    <div
      class="trustpilot-widget desktop-widget"
      data-locale="en-GB"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="597b326a0000ff0005a79eac"
      data-style-height="20px"
      data-style-width="100%"
      data-theme="light"
      ref="trustpilotWidgetDesktop"
    >
      <a
        href="https://uk.trustpilot.com/review/unihomes.co.uk"
        target="_blank"
        rel="noopener"
        >Trustpilot</a
      >
    </div>

    <div
      class="trustpilot-widget mobile-widget"
      data-locale="en-GB"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="597b326a0000ff0005a79eac"
      data-style-height="50px"
      data-style-width="100%"
      data-theme="light"
      ref="trustpilotWidgetMobile"
    >
      <a
        href="https://uk.trustpilot.com/review/unihomes.co.uk"
        target="_blank"
        rel="noopener"
        >Trustpilot</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TrustpilotWidget",
  mounted() {
    const desktopTrustbox = this.$refs.trustpilotWidgetDesktop;
    const mobileTrustbox = this.$refs.trustpilotWidgetMobile;

    function loadTrustpilot() {
      if (!window.Trustpilot) {
        window.setTimeout(loadTrustpilot, 1000);
      } else {
        window.Trustpilot.loadFromElement(desktopTrustbox);
        window.Trustpilot.loadFromElement(mobileTrustbox);
      }
    }

    loadTrustpilot();
  },
};
</script>

<style lang="scss" scoped>
.trustpilot-widget {
  text-align: center;
}

.desktop-widget {
  @include media("<medium") {
    display: none;
  }
}

.mobile-widget {
  @include media(">=medium") {
    display: none;
  }
}
</style>
